/* Coleção: ordenação (x-listbox), formulário de filtros e paginação re-renderizam a seção sem recarregar a página
   (?section_id=…, como o Impact). */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const secOf = () => (document.getElementById('shopify-section-tcb-main-search') ? 'tcb-main-search' : 'tcb-main-collection');

  const update = async (url, push = true) => {
    const SEC = secOf();
    const u = new URL(url, location.origin);
    u.searchParams.delete('section_id');
    const f = new URL(u); f.searchParams.set('section_id', SEC);
    const box = document.getElementById(`shopify-section-${SEC}`);
    if (!box) { location.href = u.toString(); return; }
    box.querySelector('.collection__results')?.setAttribute('aria-busy', 'true');
    const html = await (await fetch(f.toString())).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById(`shopify-section-${SEC}`) || doc.querySelector('.shopify-section');
    if (!fresh) { location.href = u.toString(); return; }
    box.innerHTML = fresh.innerHTML;
    if (push) history.pushState({ tcbFacet: true }, '', u.toString());
    document.dispatchEvent(new CustomEvent('tcb:content', { detail: box }));
    const top = box.querySelector('.collection__top-bar') || box;
    const y = top.getBoundingClientRect().top + scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0) - 20;
    if (y < scrollY) scrollTo({ top: y, behavior: 'smooth' });
  };

  const formUrl = (form, extra = {}) => {
    const sp = new URLSearchParams(new FormData(form));
    const url = new URL(form.getAttribute('action') || location.pathname, location.origin);
    sp.forEach((v, k) => url.searchParams.append(k, v));
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach((k) => { if (url.searchParams.get(k) === '') url.searchParams.delete(k); });
    url.searchParams.delete('section_id');
    Object.entries(extra).forEach(([k, v]) => url.searchParams.set(k, v));
    return url;
  };

  // ordenação no popover
  document.addEventListener('click', (e) => {
    const opt = e.target.closest('facet-sort-by x-listbox [role="option"]');
    if (!opt) return;
    const lb = opt.closest('x-listbox');
    $$('[role="option"]', lb).forEach((o) => o.setAttribute('aria-selected', o === opt ? 'true' : 'false'));
    const lab = document.getElementById(lb.getAttribute('aria-owns'));
    if (lab) lab.textContent = opt.textContent.trim();
    opt.closest('x-popover')?.hide?.();
    const form = opt.closest('.shopify-section')?.querySelector('form#facet-form');
    const url = form ? formUrl(form, { sort_by: opt.value }) : new URL(location.href);
    if (!form) url.searchParams.set('sort_by', opt.value);
    url.searchParams.delete('page');
    update(url);
  });

  // filtros (gaveta): mudança -> re-renderiza; aplicar fecha a gaveta
  let t;
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form#facet-form');
    if (!form || e.target.type === 'range') return;
    clearTimeout(t); t = setTimeout(() => update(formUrl(form)), 300);
  });
  document.addEventListener('submit', (e) => {
    if (e.target.id !== 'facet-form') return;
    e.preventDefault(); update(formUrl(e.target));
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[is="facet-apply-button"]');
    if (b) { document.getElementById('facets-drawer')?.hide?.(); return; }
    const a = e.target.closest('a[is="facet-link"]');
    if (a) { e.preventDefault(); update(a.href); }
  });
  addEventListener('popstate', (e) => { if (e.state && e.state.tcbFacet) update(location.href, false); });

  // faixa de preço: sliders <-> campos
  document.addEventListener('input', (e) => {
    const pr = e.target.closest('price-range');
    if (!pr) return;
    const [r1, r2] = $$('input[type="range"]', pr);
    const [n1, n2] = $$('input[type="number"]', pr);
    if (e.target === r1 || e.target === r2) {
      if (parseFloat(r1.value) > parseFloat(r2.value)) { if (e.target === r1) r1.value = r2.value; else r2.value = r1.value; }
      n1.value = r1.value; n2.value = r2.value;
    } else { if (e.target === n1) r1.value = n1.value || 0; if (e.target === n2) r2.value = n2.value || r2.max; }
    const max = parseFloat(r1.max) || 1;
    pr.querySelector('.range-group')?.style.setProperty('--range-min', `${(parseFloat(r1.value) / max) * 100}%`);
    pr.querySelector('.range-group')?.style.setProperty('--range-max', `${(parseFloat(r2.value) / max) * 100}%`);
  });
  document.addEventListener('change', (e) => {
    const pr = e.target.closest('price-range');
    if (pr && e.target.type === 'range') { const n = $$('input[type="number"]', pr)[e.target === $$('input[type="range"]', pr)[0] ? 0 : 1]; n.dispatchEvent(new Event('change', { bubbles: true })); }
  });
})();

/* Loox: documento renderizado do widget servido como srcdoc (biblioteca apps/loox). */
(() => {
  const run = () => {
    const mobile = () => matchMedia('(max-width: 699px)').matches;
    document.querySelectorAll('[data-tcb-loox-frame]').forEach((w) => {
      const src = (mobile() && w.querySelector('script.tcb-loox-doc-m')) || w.querySelector('script.tcb-loox-doc');
      if (!src || w.querySelector('iframe')) return;
      const f = document.createElement('iframe');
      f.id = 'looxReviewsFrame'; f.title = 'Reviews widget';
      f.setAttribute('frameborder', '0'); f.setAttribute('scrolling', 'no'); f.setAttribute('width', '100%');
      f.style.cssText = 'overflow:hidden;width:100%;border:0;box-shadow:unset;outline:unset;color-scheme:none;';
      f.srcdoc = src.textContent;
      const fit = () => {
        try {
          const d = f.contentDocument;
          const h = Math.max(d.documentElement.scrollHeight, d.body.scrollHeight);
          f.style.height = h + 'px'; f.setAttribute('height', h + 'px'); w.style.height = h + 'px';
        } catch (e) { /* noop */ }
      };
      f.addEventListener('load', () => { fit(); setTimeout(fit, 400); setTimeout(fit, 1500); });
      addEventListener('resize', () => setTimeout(fit, 150));
      w.append(f);
    });
  };
  (window.tcbModules = window.tcbModules || []).push(run);
})();

/* video-media (Impact): autoplay quando entra na tela, clique para tocar; atributos loaded/can-play/playing como o tema. */
(() => {
  const run = () => {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); play(e.target); } }));
    const play = (vm) => {
      if (vm.hasAttribute('playing')) return;
      const v = vm.querySelector('video');
      if (!v) return;
      if (!vm._wired) {
        vm._wired = true;
        v.addEventListener('play', () => { vm.setAttribute('playing', ''); vm.removeAttribute('suspended'); });
        v.addEventListener('pause', () => { if (!v.seeking && v.paused) vm.removeAttribute('playing'); });
      }
      vm.setAttribute('loaded', ''); vm.setAttribute('can-play', '');
      const p = v.play();
      if (p && p.catch) p.catch((err) => { if (err.name === 'NotAllowedError') { vm.setAttribute('suspended', ''); v.controls = true; } });
    };
    document.querySelectorAll('video-media').forEach((vm) => {
      if (vm.hasAttribute('host')) return;
      if (vm.hasAttribute('autoplay')) io.observe(vm);
      else vm.addEventListener('click', () => play(vm), { once: true });
    });
  };
  (window.tcbModules = window.tcbModules || []).push(run);
})();

/* Pop-ups nativos (sem app): flyout VIP de 4 etapas (formulário de cliente da Shopify) e upsell -60% do Coussin Lombaire. */
(() => {
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* noop */ } }
  };
  const DAY = 864e5;
  const recently = (k) => { const t = parseInt(store.get(k) || '0', 10); return t && Date.now() - t < DAY; };

  /* ---------------- flyout VIP ---------------- */
  const vip = () => {
    const el = document.getElementById('tcb-vip');
    if (!el) return;
    const steps = Array.from(el.querySelectorAll('.tcb-vip__step'));
    const imgs = Array.from(el.querySelectorAll('[data-step-img]'));
    const state = { position: '', pour: '' };
    const go = (n) => {
      steps.forEach((s) => (s.hidden = s.getAttribute('data-step') !== String(n)));
      imgs.forEach((i) => (i.hidden = i.getAttribute('data-step-img') !== String(n)));
      el.querySelector('.tcb-vip__body').scrollTop = 0;
      store.set('tcb-vip-step', String(n));
    };
    const open = (n = 1) => { go(n); el.hidden = false; el.setAttribute('aria-hidden', 'false'); };
    const close = () => {
      el.hidden = true; el.setAttribute('aria-hidden', 'true');
      if (store.get('tcb-vip-done') !== '1') store.set('tcb-vip-closed', String(Date.now()));
    };
    el.addEventListener('click', (e) => {
      if (e.target.closest('[data-tcb-vip-close]')) { close(); return; }
      const f = e.target.closest('[data-tcb-vip-for]');
      if (f) {
        state.pour = f.getAttribute('data-tcb-vip-for');
        state.position = (el.querySelector('input[name="position"]:checked') || {}).value || '';
        go(2); return;
      }
      const nx = e.target.closest('[data-tcb-vip-next]');
      if (nx) { go(nx.getAttribute('data-tcb-vip-next')); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !el.hidden) close(); });

    // etapa 2: inscrição nativa (cliente com marketing por e-mail) pelo formulário da Shopify
    const form = el.querySelector('#tcb-vip-customer');
    const email = () => form.querySelector('input[type="email"]').value.trim();
    // Envio NATIVO (sem fetch): o captcha da Shopify dos formulários de cliente intercepta o submit quando precisa;
    // depois do envio a Shopify volta com ?customer_posted=true e o flyout reabre na etapa seguinte.
    let mode = 'email';
    form.addEventListener('submit', (e) => {
      const err = form.querySelector('.tcb-vip__error');
      if (mode === 'email') {
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email())) { e.preventDefault(); err.hidden = false; return; }
        err.hidden = true;
        const tags = ['newsletter', 'popup-60', state.position && `position-${state.position}`, state.pour && `pour-${state.pour}`].filter(Boolean).join(',');
        form.querySelector('input[name="contact[tags]"]').value = tags;
        store.set('tcb-vip-email', email());
        store.set('tcb-vip-resume', '3');
      } else {
        store.set('tcb-vip-resume', '4');
      }
      form.querySelector('[type="submit"]').setAttribute('aria-busy', 'true');
    });
    // etapa 3: telefone -> mesmo formulário de cliente (e-mail + telefone), envio nativo
    el.querySelector('[data-tcb-vip-phone]').addEventListener('click', () => {
      const ph = el.querySelector('#tcb-vip-phone').value.trim();
      const em = store.get('tcb-vip-email') || '';
      if (!ph || !em) { go(4); return; }
      mode = 'phone';
      form.querySelector('input[type="email"]').value = em;
      let pi = form.querySelector('input[name="contact[phone]"]');
      if (!pi) { pi = document.createElement('input'); pi.type = 'hidden'; pi.name = 'contact[phone]'; form.append(pi); }
      pi.value = ph;
      form.querySelector('input[name="contact[tags]"]').value = 'newsletter,popup-60,vip-sms';
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });

    // volta do envio: abre a etapa seguinte
    const resume = store.get('tcb-vip-resume');
    if (resume && /customer_posted=true/.test(location.search)) {
      store.set('tcb-vip-resume', ''); store.set('tcb-vip-done', '1'); open(resume); return;
    }
    if (resume) store.set('tcb-vip-resume', '');
    if (store.get('tcb-vip-done') === '1' || recently('tcb-vip-closed') || document.documentElement.dataset.customer === '1') return;
    setTimeout(() => { if (!document.querySelector('#tcb-upsell:not([hidden])')) open(1); }, 12000);
  };

  /* ---------------- upsell -60% ---------------- */
  const upsell = () => {
    const el = document.getElementById('tcb-upsell');
    if (!el) return;
    const pid = Number(el.getAttribute('data-product-id'));
    const vid = Number(el.getAttribute('data-variant-id'));
    const openDrawer = () => { const d = document.getElementById('cart-drawer'); if (d && d.show) d.show(); };
    const close = (drawer = true) => { el.hidden = true; if (drawer) openDrawer(); };
    // depois de adicionar o produto principal: mostra o pop-up em vez de abrir a gaveta (1 vez por dia)
    window.tcbInterceptAdd = (form) => {
      const fpid = Number((form.querySelector('[name="product-id"]') || {}).value || 0);
      if (fpid !== pid || recently('tcb-upsell-shown')) return false;
      store.set('tcb-upsell-shown', String(Date.now()));
      const vipEl = document.getElementById('tcb-vip'); if (vipEl) vipEl.hidden = true;
      el.hidden = false;
      return true;
    };
    el.addEventListener('click', async (e) => {
      if (e.target.closest('[data-tcb-up-close]')) { close(); return; }
      const b = e.target.closest('[data-tcb-up-add]');
      if (!b) return;
      b.setAttribute('aria-busy', 'true');
      try {
        await fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) });
      } catch (err) { /* noop */ }
      b.removeAttribute('aria-busy');
      el.hidden = true;
      if (window.tcbCart) window.tcbCart.refresh(true); else openDrawer();
    });
  };

  (window.tcbModules = window.tcbModules || []).push(() => { vip(); upsell(); });
})();

/* PDP: galeria (media-carousel + miniaturas + cursor), seletor de variantes com re-renderização pela seção
   (?option_values=…&section_id=…, como o Impact), quantidade, barra fixa e quick-buy dos cards. */
(() => {
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = () => matchMedia('screen and (pointer: fine)').matches;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- cursor personalizado ---------- */
  const cursors = () => {
    $$('custom-cursor').forEach((c) => {
      const p = c.parentElement;
      if (!p || c._tcb) return; c._tcb = true;
      p.addEventListener('pointerleave', () => c.classList.remove('is-visible', 'is-half-start', 'is-half-end'));
      p.addEventListener('pointermove', (e) => {
        if (e.target.matches('button, a[href], button *, a[href] *')) { c.classList.remove('is-visible'); return; }
        const r = p.getBoundingClientRect();
        const start = e.clientX < (r.left + r.right) / 2;
        c.classList.toggle('is-half-start', start); c.classList.toggle('is-half-end', !start); c.classList.add('is-visible');
        const y = e.clientY - r.y - c.clientHeight / 2, x = e.clientX - r.x - c.clientWidth / 2;
        c.style.translate = `${x.toFixed(3)}px ${y.toFixed(3)}px`;
      });
    });
  };

  /* ---------- galeria ---------- */
  class Gallery {
    constructor(mc) {
      this.mc = mc; this.idx = parseInt(mc.getAttribute('initial-index') || '0', 10) || 0;
      this.dots = $$(`page-dots[aria-controls="${mc.id}"]`);
      mc.addEventListener('scroll', () => this.onScroll(), { passive: true });
      mc.addEventListener('scrollend', () => this.settle());
      mc.addEventListener('click', (e) => {
        if (e.target.closest('button, a[href]') || !fine()) return;
        const cur = this.items[this.idx];
        if (!cur || cur.getAttribute('data-media-type') !== 'image') return;
        const r = mc.getBoundingClientRect();
        (e.clientX - r.left > mc.clientWidth / 2) ? this.go(this.vis.indexOf(cur) + 1) : this.go(this.vis.indexOf(cur) - 1);
      });
      this.dots.forEach((d) => d.addEventListener('click', (e) => {
        const b = e.target.closest('button'); if (!b) return;
        const i = $$('button', d).indexOf(b);
        this.goItem(this.items[i]);
      }));
      new ResizeObserver(() => this.height()).observe(mc);
      this.mark(this.items[this.idx] && !this.items[this.idx].hidden ? this.items[this.idx] : this.vis[0]);
    }
    get items() { return $$(':scope > .product-gallery__media', this.mc); }
    get vis() { return this.items.filter((x) => !x.hidden); }
    offset() { const v = this.vis; return v.length < 2 ? (this.mc.clientWidth || 1) : v[1].offsetLeft - v[0].offsetLeft; }
    go(vi) { const v = this.vis; if (!v.length) return; vi = Math.max(0, Math.min(v.length - 1, vi)); this.goItem(v[vi]); }
    goItem(it, animate = true) {
      if (!it) return;
      this.mark(it);
      this._prog = animate && !reduce && !document.hidden;
      this.mc.scrollTo({ left: this.offset() * this.vis.indexOf(it), behavior: this._prog ? 'smooth' : 'auto' });
      if (!this._prog) this.settle();
    }
    onScroll() {
      if (this._prog) return;
      const it = this.vis[Math.round(this.mc.scrollLeft / this.offset())];
      if (it && this.items.indexOf(it) !== this.idx) this.mark(it, false);
      clearTimeout(this._t); this._t = setTimeout(() => this.settle(), 160);
    }
    settle() { this._prog = false; const it = this.items[this.idx]; this.items.forEach((x) => x.classList.toggle('is-selected', x === it)); this.height(); }
    mark(it, sel = true) {
      if (!it) return;
      this.idx = this.items.indexOf(it);
      if (sel) this.items.forEach((x) => x.classList.toggle('is-selected', x === it));
      this.dots.forEach((d) => {
        const bs = $$('button', d);
        bs.forEach((b, i) => b.setAttribute('aria-current', i === this.idx ? 'true' : 'false'));
        const b = bs[this.idx];
        if (b && d.hasAttribute('align-selected') && d.scrollHeight + d.scrollWidth > d.clientHeight + d.clientWidth) {
          const horiz = d.scrollWidth > d.clientWidth;
          if (horiz) d.scrollTo({ left: b.offsetLeft - d.clientWidth / 2 + b.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
          else d.scrollTo({ top: b.offsetTop - d.clientHeight / 2 + b.clientHeight / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
      this.height();
    }
    height() {
      if (!this.mc.hasAttribute('adaptive-height')) return;
      const it = this.items[this.idx];
      this.mc.style.maxHeight = '';
      if (it && this.mc.scrollWidth > this.mc.clientWidth) this.mc.style.maxHeight = `${it.clientHeight}px`;
    }
    /* filtro (VIA): ids visíveis vindos do HTML re-renderizado */
    filter(hiddenIds) {
      this.items.forEach((x, i) => {
        const h = hiddenIds.has(x.getAttribute('data-media-id'));
        x.hidden = h;
        this.dots.forEach((d) => { const b = $$('button', d)[i]; if (b) b.hidden = h; });
      });
    }
  }
  const galleries = new Map();
  const initGalleries = (scope = document) => {
    $$('media-carousel', scope).forEach((mc) => { if (!galleries.has(mc)) galleries.set(mc, new Gallery(mc)); });
  };

  /* ---------- quantidade ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('quantity-selector .quantity-selector__button');
    if (!b) return;
    const qs = b.closest('quantity-selector'); const inp = qs.querySelector('input');
    const bs = $$('.quantity-selector__button', qs);
    const min = parseInt(inp.min || '1', 10);
    const n = Math.max(inp.closest('line-item') ? 0 : min, (parseInt(inp.value, 10) || min) + (b === bs[0] ? -1 : 1));
    inp.value = n;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- seletor de variantes ---------- */
  const PARTIAL = ['sku', 'badges', 'price', 'payment-terms', 'variant-picker', 'quantity-selector', 'volume-pricing', 'inventory', 'buy-buttons', 'pickup-availability', 'liquid'];
  const cache = new Map();
  const findDeep = (frag, sel) => {
    const x = frag.querySelector(sel);
    if (x) return x;
    for (const t of frag.querySelectorAll('template')) { const y = findDeep(t.content, sel); if (y) return y; }
    return null;
  };
  const renderFor = (vp, values) => {
    const url = `${root}products/${vp.getAttribute('handle')}?option_values=${values.join(',')}&section_id=${vp.getAttribute('section-id')}`;
    if (!cache.has(url)) cache.set(url, fetch(url).then((r) => r.text()));
    return cache.get(url);
  };
  const onOption = async (e) => {
    const inp = e.target.closest('input[data-option-position]');
    if (!inp || !inp.name.includes('option')) return;
    const fid = inp.getAttribute('form');
    const form = document.forms[fid];
    const vp = $$(`variant-picker[form-id="${fid}"]`)[0];
    if (!form || !vp) return;
    const values = Array.from(form.elements).filter((x) => x.matches && x.matches('input[data-option-position]:checked'))
      .sort((a, b) => a.getAttribute('data-option-position') - b.getAttribute('data-option-position')).map((x) => x.value);
    // fecha a lista suspensa
    const pop = inp.closest('x-popover'); if (pop && pop.hasAttribute('close-on-listbox-select') && pop.hide) pop.hide();
    const html = await renderFor(vp, values);
    const frag = document.createRange().createContextualFragment(html);
    const nvp = findDeep(frag, `variant-picker[form-id="${fid}"]`);
    const variant = JSON.parse(nvp?.querySelector('script[data-variant]')?.textContent || '{}');
    // blocos
    $$('product-rerender').forEach((pr) => {
      if (pr.getAttribute('observe-form') !== fid) return;
      const m = findDeep(frag, `#${CSS.escape(pr.id)}`);
      if (!m) return;
      if (!pr.hasAttribute('allow-partial-rerender')) { pr.replaceWith(document.importNode(m, true)); return; }
      PARTIAL.forEach((t) => $$(`[data-block-type="${t}"]`, pr).forEach((el) => {
        const nb = m.querySelector(`[data-block-type="${t}"][data-block-id="${el.getAttribute('data-block-id')}"]`);
        if (!nb) return;
        if (t === 'buy-buttons') { const a = el.querySelector('buy-buttons'), b = nb.querySelector('buy-buttons'); if (a && b) a.replaceWith(document.importNode(b, true)); }
        else if (t === 'quantity-selector') { const q = el.querySelector('.quantity-selector__input')?.value; const n = document.importNode(nb, true); el.replaceWith(n); const ni = n.querySelector('.quantity-selector__input'); if (ni && q) ni.value = q; }
        else el.replaceWith(document.importNode(nb, true));
      }));
    });
    if (variant.id && form.elements.id) { form.elements.id.value = variant.id; form.elements.id.dispatchEvent(new Event('change', { bubbles: true })); }
    if (vp.hasAttribute('update-url') && variant.id) { const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState({ path: u.toString() }, '', u.toString()); }
    // galeria: filtro (VIA) e mídia da variante
    const gal = $$(`product-gallery[form="${fid}"]`)[0];
    if (gal) {
      const ng = findDeep(frag, 'media-carousel');
      $$('media-carousel', gal).forEach((mc) => {
        const g = galleries.get(mc); if (!g) return;
        if (ng) g.filter(new Set($$(':scope > .product-gallery__media[hidden]', ng).map((x) => x.getAttribute('data-media-id'))));
        const fm = variant.featured_media && variant.featured_media.id;
        const it = fm ? g.items.find((x) => x.getAttribute('data-media-id') === String(fm)) : g.vis[0];
        g.goItem(it && !it.hidden ? it : g.vis[0], false);
      });
    }
    form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
  };
  document.addEventListener('change', onOption);

  /* ---------- barra fixa ---------- */
  const quickAdd = () => {
    $$('product-quick-add').forEach((qa) => {
      const from = document.getElementById(qa.getAttribute('form')), to = document.querySelector('.footer');
      if (!from || !to) return;
      let passed = false, reached = false;
      new IntersectionObserver((es) => {
        es.forEach((en) => { if (en.target === from) passed = en.boundingClientRect.bottom < 0; if (en.target === to) reached = en.isIntersecting; });
        qa.classList.toggle('is-visible', passed && !reached);
      }).observe(from);
      new IntersectionObserver((es) => {
        es.forEach((en) => { if (en.target === to) reached = en.isIntersecting; });
        qa.classList.toggle('is-visible', passed && !reached);
      }).observe(to);
    });
  };

  /* ---------- quick-buy dos cards: carrega o conteúdo e só então abre (como o Impact) ---------- */
  const loadQuickBuy = async (d) => {
    const [handle, qs] = (d.getAttribute('handle') || '').split('?');
    const html = await (await fetch(`${root}products/${handle}?${qs ? qs + '&' : ''}section_id=tcb-main-product`)).text();
    const t = new DOMParser().parseFromString(html, 'text/html').querySelector('template#quick-buy-content');
    if (!t) return false;
    const c = document.importNode(t.content, true);
    c.querySelectorAll('noscript').forEach((n) => n.remove());
    d.replaceChildren(...c.childNodes);
    d._loaded = true;
    return true;
  };
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[aria-controls^="quick-buy"]');
    if (!b) return;
    const d = document.getElementById(b.getAttribute('aria-controls'));
    if (!d || !d.matches('quick-buy-drawer') || d._loaded || d.hasAttribute('open')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    [d, b].forEach((x) => x.setAttribute('aria-busy', 'true'));
    try { await loadQuickBuy(d); } finally { [d, b].forEach((x) => x.setAttribute('aria-busy', 'false')); }
    d.show();
  }, true);

  const run = () => { cursors(); initGalleries(); quickAdd(); };
  (window.tcbModules = window.tcbModules || []).push(run);
})();

/* Aparição ao rolar (mesmos tempos da referência: títulos split_fade, media-with-text, reveal-items com escalonamento). */
(() => {
  const noMotion = !matchMedia('(prefers-reduced-motion: no-preference)').matches;

  /* split-lines: separa o texto em linhas (shadow DOM) para animar linha a linha */
  if (!customElements.get('split-lines')) {
    customElements.define('split-lines', class extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' }).innerHTML = '<slot></slot>';
        this._w = innerWidth; this._need = true;
        addEventListener('resize', () => { if (this._w !== innerWidth) { this._w = innerWidth; this.split(true); } });
      }
      connectedCallback() { this.split(); }
      get lines() { return Array.from(this.shadowRoot.children).filter((x) => x.tagName === 'SPAN'); }
      split(force) {
        if (!this._need && !force) return;
        const sr = this.shadowRoot;
        sr.innerHTML = this.textContent.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c])).replace(/&[a-z]+;|./g, '<span>$&</span>').replace(/\s/g, ' ');
        const rows = new Map();
        Array.from(sr.children).forEach((l) => { const k = Math.round(l.getBoundingClientRect().top); rows.set(k, (rows.get(k) || '') + l.textContent); });
        sr.innerHTML = '';
        rows.forEach((txt) => {
          // mesmo espaço em branco entre as linhas da marcação do Impact (separa as palavras entre linhas)
          sr.appendChild(document.createTextNode(' '));
          const o = document.createElement('span'); o.style.display = 'inline-block';
          const i = document.createElement('span'); i.style.display = 'block'; i.textContent = txt;
          o.appendChild(i); sr.appendChild(o);
          sr.appendChild(document.createTextNode(' '));
        });
        this._need = false;
      }
    });
  }

  const show = (el, frames, opts) => {
    if (!el) return;
    el.style.opacity = '1';
    if (noMotion) return;
    el.animate(frames, { fill: 'backwards', easing: 'ease', ...opts });
  };
  const heading = (el, delay = 0) => {
    if (!el) return;
    const lines = el.querySelector('split-lines')?.lines;
    if (!lines || !lines.length) { show(el, { opacity: [0, 1] }, { duration: 200, delay }); return; }
    el.style.opacity = '1';
    if (noMotion) return;
    lines.forEach((ln, i) => ln.animate({ transform: ['translateY(0.5em)', 'translateY(0)'], opacity: [0, 1] },
      { duration: 300, delay: delay + i * 100, fill: 'backwards', easing: 'ease' }));
  };
  const inView = (el, fn, margin) => {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); fn(e.target); } }), { rootMargin: margin || '0px' });
    io.observe(el);
  };
  const imgReady = (img) => (!img || img.complete ? Promise.resolve() : new Promise((r) => { img.addEventListener('load', r, { once: true }); img.addEventListener('error', r, { once: true }); }));

  const run = (root = document) => {
    const done = new WeakSet();
    // media-with-text: mídia (opacidade + zoom) e texto com atraso
    root.querySelectorAll('media-with-text .media-with-text__item').forEach((item) => {
      inView(item, () => {
        const media = item.querySelector('.media-with-text__media');
        const prose = item.querySelector('.media-with-text__content > .prose');
        [media, prose].forEach((x) => x && done.add(x));
        imgReady(media?.querySelector('img')).then(() => {
          show(media, { opacity: [0, 1] }, { duration: 300 });
          const m = media?.querySelector('img, video-media');
          if (m && !noMotion) m.animate({ transform: ['scale(1.05)', 'scale(1)'] }, { duration: 300, easing: 'ease' });
        });
        show(prose, { opacity: [0, 1] }, { duration: 200, delay: 300 });
      });
      item.querySelectorAll('[reveal-on-scroll="true"]').forEach((x) => done.add(x));
    });
    // cabeçalhos de seção
    root.querySelectorAll('section-header').forEach((sh) => {
      const h = sh.querySelector('h2[reveal-on-scroll="true"]');
      if (!h) return;
      done.add(h);
      inView(sh, () => heading(h), '0px 0px -100px 0px');
    });
    // listas de produtos com escalonamento
    root.querySelectorAll('reveal-items').forEach((ri) => {
      inView(ri, () => {
        ri.style.opacity = '1';
        if (noMotion) return;
        const kids = ri.hasAttribute('selector') ? ri.querySelectorAll(ri.getAttribute('selector')) : ri.children;
        Array.from(kids).forEach((k, i) => k.animate({ opacity: [0, 1], transform: ['translateY(15px)', 'translateY(0)'] },
          { duration: 350, delay: i * 50, fill: 'backwards', easing: 'ease' }));
      }, ri.getAttribute('margin') || '-50px 0px');
    });
    // listas de coleções
    root.querySelectorAll('[reveal-js]').forEach((el) => {
      inView(el, () => {
        el.style.opacity = '1';
        const img = el.querySelector('img, svg');
        if (img && !noMotion) img.animate({ opacity: [0, 1], transform: ['scale(1.03)', 'none'] }, { duration: 200, fill: 'backwards' });
      }, '-100px');
    });
    // demais elementos com reveal-on-scroll: aparição simples (fora do slideshow, que tem lógica própria)
    root.querySelectorAll('[reveal-on-scroll="true"]').forEach((el) => {
      if (done.has(el) || el.closest('slideshow-carousel, x-slideshow')) return;
      inView(el, () => (el.matches('h1,h2,h3,p') ? heading(el) : show(el, { opacity: [0, 1] }, { duration: 250 })));
    });
  };
  document.addEventListener('tcb:content', (e) => run(e.detail));
  (window.tcbModules = window.tcbModules || []).push(Object.assign(() => run(document), { tcbName: 'reveal' }));
})();

/* Página do carrinho: country-selector (regiões) e estimador de frete (API de taxas do Shopify), textos do Impact. */
(() => {
  const S = {
    none: 'Nous ne livrons pas à votre adresse.',
    one: 'Il y a un résultat pour votre adresse :',
    many: 'Il y a plusieurs résultats pour votre adresse :',
    err: "Impossible d'estimer les frais de livraison :"
  };
  const provinces = (cs) => {
    const c = cs.querySelector('select[name$="[country]"]'), p = cs.querySelector('select[name$="[province]"]');
    if (!c || !p) return;
    const fill = () => {
      const opt = c.options[c.selectedIndex];
      const list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]');
      p.innerHTML = list.map(([v, l]) => `<option value="${v}">${l}</option>`).join('');
      p.closest('.form-control').style.display = list.length ? '' : 'none';
    };
    c.addEventListener('change', fill);
    if (c.getAttribute('data-default')) c.value = c.getAttribute('data-default');
    fill();
  };
  const run = () => {
    document.querySelectorAll('country-selector').forEach(provinces);
  };
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('.shipping-estimator__form');
    if (!f) return;
    e.preventDefault();
    const est = f.closest('shipping-estimator');
    const out = est.querySelector('.shipping-estimator__results');
    const btn = f.querySelector('[type="submit"]'); btn?.setAttribute('aria-busy', 'true');
    const q = new URLSearchParams(new FormData(f)).toString().replace(/address%5B/g, 'shipping_address%5B');
    try {
      const r = await fetch(`/cart/prepare_shipping_rates.json?${q}`, { method: 'POST' });
      if (!r.ok) { const j = await r.json(); throw new Error(Object.entries(j).map(([k, v]) => `${k} ${v}`).join(', ')); }
      let rates = null;
      for (let i = 0; i < 20 && !rates; i++) {
        const a = await fetch(`/cart/async_shipping_rates.json?${q}`);
        const j = await a.json();
        if (j && j.shipping_rates) rates = j.shipping_rates; else await new Promise((res) => setTimeout(res, 500));
      }
      rates = rates || [];
      const money = window.tcbMoney || ((c) => c);
      out.innerHTML = `<p>${rates.length === 0 ? S.none : rates.length === 1 ? S.one : S.many}</p>`
        + (rates.length ? `<ul class="unordered-list text-sm">${rates.map((x) => `<li>${x.presentment_name || x.name}: ${money(Math.round(parseFloat(x.price) * 100))}</li>`).join('')}</ul>` : '');
    } catch (err) {
      out.innerHTML = `<p>${S.err}</p><ul class="unordered-list text-sm"><li>${err.message}</li></ul>`;
    }
    out.hidden = false;
    btn?.removeAttribute('aria-busy');
  });
  document.addEventListener('tcb:content', (e) => e.detail.querySelectorAll('country-selector').forEach(provinces));
  (window.tcbModules = window.tcbModules || []).push(run);
})();

/* "Stories" das PDPs Oreiller 2.0/3.0 (bloco liquid da referência, script inline removido pelo espelho):
   miniaturas tocam sem som por 10 s e voltam ao início; clique abre a modal com o vídeo completo; overlay ou × fecha.
   Delegação no document: a seção do produto é re-renderizada ao trocar de variante. */
(() => {
  const tease = (root) => {
    root.querySelectorAll('.soya-thumb-video:not([data-tcb-teased])').forEach((v) => {
      v.setAttribute('data-tcb-teased', '');
      v.muted = true;
      const p = v.play();
      if (p && p.then) {
        p.then(() => setTimeout(() => { v.pause(); v.currentTime = 0; }, 10000)).catch(() => { /* autoplay bloqueado: fica o 1º quadro */ });
      }
    });
  };
  const close = (modal) => {
    const v = modal.querySelector('video');
    if (v) v.pause();
    modal.classList.remove('active');
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.soya-story');
    if (btn) {
      const modal = document.getElementById('soyaStoryModal');
      const video = document.getElementById('soyaStoryVideo');
      if (!modal || !video) return;
      e.preventDefault();
      const src = btn.getAttribute('data-video');
      const s = video.querySelector('source');
      if (s) s.setAttribute('src', src); else video.setAttribute('src', src);
      video.load();
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
      modal.classList.add('active');
      return;
    }
    const modal = e.target.closest('#soyaStoryModal');
    if (modal && (e.target.classList.contains('soya-story-overlay') || e.target.closest('.soya-story-close'))) close(modal);
  });
  document.addEventListener('keydown', (e) => {
    const modal = document.querySelector('#soyaStoryModal.active');
    if (modal && e.key === 'Escape') close(modal);
  });
  (window.tcbModules = window.tcbModules || []).push(() => {
    tease(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) tease(n); })))
      .observe(document.body, { childList: true, subtree: true });
  });
})();

/* Espelho — comportamento do espelho da referência (Impact 6.4.1), escrito do zero para a mesma marcação.
   O JS licenciado do Impact (theme.js / vendor.min.js) não é copiado. Cada módulo roda isolado (try/catch). */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const T = window.TCB || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- dinheiro ---------------- */
  const money = (cents, fmt) => {
    fmt = fmt || T.moneyFormat || '€{{amount_with_comma_separator}}';
    const v = (Number(cents) || 0) / 100;
    const fix = (n, d) => n.toFixed(d);
    const group = (s, th, dec) => { const [i, f] = s.split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: group(fix(v, 2), ',', '.'), amount_no_decimals: group(fix(v, 0), ',', '.'),
      amount_with_comma_separator: group(fix(v, 2), '.', ','), amount_no_decimals_with_comma_separator: group(fix(v, 0), '.', ','),
      amount_with_space_separator: group(fix(v, 2), ' ', ','), amount_with_period_and_space_separator: group(fix(v, 2), ' ', '.')
    }[k] ?? group(fix(v, 2), '.', ',')));
  };
  window.tcbMoney = money;

  /* ---------------- diálogos (x-drawer / x-popover e derivados) ---------------- */
  const lock = { n: 0 };
  const scrollLock = (on) => {
    lock.n = Math.max(0, lock.n + (on ? 1 : -1));
    document.documentElement.style.overflow = lock.n ? 'hidden' : '';
  };

  class TcbDialog extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const tplId = this.classList.contains('popover') ? 'popover-default-template' : 'drawer-default-template';
      const tpl = document.getElementById(tplId);
      if (!this.shadowRoot && tpl) {
        this.attachShadow({ mode: 'open' }).appendChild(tpl.content.cloneNode(true));
      }
      const sr = this.shadowRoot;
      if (sr) {
        const vis = (slot) => { if (['header', 'footer', 'body'].includes(slot.name)) slot.parentElement.hidden = slot.assignedElements({ flatten: true }).length === 0; };
        sr.querySelectorAll('slot').forEach(vis);
        sr.addEventListener('slotchange', (e) => vis(e.target));
        sr.addEventListener('click', (e) => {
          const p = e.target.closest('[part="overlay"],[part="close-button"],[part="outside-close-button"]');
          if (p) this.hide();
        });
      }
      this.style.visibility = 'hidden';
      if (this.classList.contains('popover')) this.style.display = 'none';
    }
    get isOpen() { return this.hasAttribute('open'); }
    controls() { return $$(`[aria-controls="${this.id}"]`); }
    show() {
      if (this.isOpen) return;
      document.dispatchEvent(new CustomEvent('tcb:dialog-open', { detail: this }));
      this.setAttribute('open', '');
      this.controls().forEach((c) => c.setAttribute('aria-expanded', 'true'));
      this.style.visibility = 'visible';
      if (this.classList.contains('popover')) {
        this.popIn();
      } else {
        if (this.tagName === 'QUICK-BUY-DRAWER') this.style.display = 'block';
        // Impact: gavetas vão para o <body> ao abrir (saem do card/seção e do seu contexto de empilhamento)
        if (this.parentElement !== document.body) { this._homeD = [this.parentElement, this.nextSibling]; document.body.append(this); }
        scrollLock(true); this._locked = true;
        this.animateIn();
      }
      this.dispatchEvent(new Event('dialog:after-show', { bubbles: true }));
    }
    hide() {
      if (!this.isOpen) return;
      this.removeAttribute('open');
      this.controls().forEach((c) => c.setAttribute('aria-expanded', 'false'));
      if (this._locked) { scrollLock(false); this._locked = false; }
      if (this.classList.contains('popover')) {
        this.popOut();
      } else {
        this.animateOut().then(() => { if (!this.isOpen) { this.style.visibility = 'hidden'; if (this.tagName === 'QUICK-BUY-DRAWER') this.style.display = 'none';
          if (this._homeD) { const [par, nx] = this._homeD; this._homeD = null; if (par && par.isConnected) par.insertBefore(this, nx && nx.parentNode === par ? nx : null); } } });
      }
      this.dispatchEvent(new Event('dialog:after-hide', { bubbles: true }));
    }
    toggle() { this.isOpen ? this.hide() : this.show(); }
    parts() { const sr = this.shadowRoot; return sr ? { c: sr.querySelector('[part="content"]'), o: sr.querySelector('[part="overlay"]') } : {}; }
    fromDir() {
      return matchMedia('screen and (max-width: 699px)').matches ? 'bottom' : (this.getAttribute('open-from') || 'right');
    }
    clip() {
      const R = ' round var(--rounded-sm))', Z = 'inset(0 0 0 0' + R, ltr = document.dir !== 'rtl';
      switch (this.fromDir()) {
        case 'left': return [ltr ? 'inset(0 100% 0 0' + R : 'inset(0 0 0 100%' + R, Z];
        case 'bottom': return ['inset(100% 0 0 0' + R, Z];
        case 'top': return ['inset(0 0 100% 0' + R, Z];
        default: return [ltr ? 'inset(0 0 0 100%' + R : 'inset(0 100% 0 0' + R, Z];
      }
    }
    initialPosition() {
      const d = this.fromDir(), ltr = document.dir !== 'rtl';
      this.style.left = (ltr && d === 'left') || (!ltr && d === 'right') ? '0px' : 'auto';
      this.style.right = this.style.left === 'auto' ? '0px' : 'auto';
      this.style.bottom = d === 'bottom' ? '0px' : '';
      this.style.top = this.style.bottom === '' ? '0px' : '';
    }
    animateIn() {
      const { c } = this.parts();
      this.initialPosition();
      if (!c) return;
      if (reduce) { this.animate({ opacity: [0, 1] }, { duration: 200 }); return; }
      const ob = this.shadowRoot.querySelector('[part="outside-close-button"]');
      this.animate({ opacity: [0, 1] }, { duration: 150 });
      c.animate({ clipPath: this.clip() }, { duration: 400, delay: 150, easing: 'cubic-bezier(.86,0,.07,1)', fill: 'backwards' });
      Array.from(c.children).concat(ob ? [ob] : []).forEach((x) => x.animate({ opacity: [0, 1] }, { duration: 150, delay: 550, fill: 'backwards' }));
    }
    animateOut() {
      const { c } = this.parts();
      if (!c) return Promise.resolve();
      if (reduce) return this.animate({ opacity: [1, 0] }, { duration: 200, fill: 'forwards' }).finished.then((a) => a.cancel()).catch(() => {});
      const ob = this.shadowRoot.querySelector('[part="outside-close-button"]');
      const fade = Array.from(c.children).concat(ob ? [ob] : []).map((x) => x.animate({ opacity: [1, 0] }, { duration: 150, fill: 'forwards' }));
      const cl = c.animate({ clipPath: this.clip().reverse() }, { duration: 400, delay: 0, easing: 'cubic-bezier(.86,0,.07,1)', fill: 'forwards' });
      const me = this.animate({ opacity: [1, 0] }, { duration: 150, delay: 300, fill: 'forwards' });
      return Promise.all([cl.finished, me.finished]).then(() => { if (!this.isOpen) this.style.visibility = 'hidden'; [cl, me, ...fade].forEach((x) => x.cancel()); }).catch(() => {});
    }
    /* popover do Impact: ancorado ao botão no desktop; abaixo de 1000px vai para o body como folha inferior */
    popIn() {
      const small = matchMedia('screen and (max-width: 999px)').matches;
      const { c } = this.parts();
      const ob = this.shadowRoot && this.shadowRoot.querySelector('[part="outside-close-button"]');
      this.style.display = 'block';
      if (small) {
        if (this.parentElement !== document.body) { this._home = [this.parentElement, this.nextSibling]; document.body.append(this); }
        scrollLock(true); this._locked = true;
        Object.assign(this.style, { left: '0px', right: '', bottom: '0px', top: '' });
        if (!reduce) {
          this.animate({ opacity: [0, 1] }, { duration: 150 });
          if (c) {
            c.animate({ clipPath: ['inset(100% 0 0 0 round 8px)', 'inset(0 0 0 0 round 8px)'] }, { duration: 400, delay: 150, easing: 'cubic-bezier(.86,0,.07,1)', fill: 'backwards' });
            Array.from(c.children).concat(ob ? [ob] : []).forEach((x) => x.animate({ opacity: [0, 1] }, { duration: 150, delay: 550, fill: 'backwards' }));
          }
        }
      } else {
        const h = this.getAttribute('anchor-horizontal') || 'end', v = this.getAttribute('anchor-vertical') || 'start';
        const sb = 'var(--popover-anchor-block-spacing)', si = 'var(--popover-anchor-inline-spacing)';
        this.style.left = h === 'start' ? si : '';
        this.style.right = h === 'end' ? si : '';
        if (v === 'center') { this.style.top = `calc(50% - ${parseInt(this.clientHeight / 2, 10)}px)`; this.style.bottom = ''; }
        else { this.style.top = v === 'end' ? `calc(100% + ${sb})` : ''; this.style.bottom = v === 'start' ? `calc(100% + ${sb})` : ''; }
        if (!reduce) this.animate({ opacity: [0, 1] }, { duration: 150 });
      }
      const f = this.getAttribute('initial-focus') && this.querySelector(this.getAttribute('initial-focus'));
      if (f && matchMedia('screen and (pointer: fine)').matches) f.focus({ preventScroll: true });
    }
    popOut() {
      const small = this.parentElement === document.body && this._home;
      const { c } = this.parts();
      const done = () => {
        if (this.isOpen) return;
        this.style.visibility = 'hidden'; this.style.display = 'none';
        if (this._home) { const [par, nx] = this._home; this._home = null; if (par && par.isConnected) par.insertBefore(this, nx && nx.parentNode === par ? nx : null); }
      };
      if (reduce) return done();
      if (small && c) {
        Array.from(c.children).forEach((x) => x.animate({ opacity: [1, 0] }, { duration: 150, fill: 'forwards' }).finished.then((a) => a.cancel()).catch(() => {}));
        c.animate({ clipPath: ['inset(0 0 0 0 round 8px)', 'inset(100% 0 0 0 round 8px)'] }, { duration: 400, easing: 'cubic-bezier(.86,0,.07,1)' }).finished
          .then(() => this.animate({ opacity: [1, 0] }, { duration: 150 }).finished).then(done, done);
      } else {
        this.animate({ opacity: [1, 0] }, { duration: 150 }).finished.then(done, done);
      }
    }
  }
  ['x-drawer', 'x-popover', 'cart-drawer', 'search-drawer', 'navigation-drawer', 'quick-buy-drawer', 'facet-drawer', 'cart-notification-drawer']
    .forEach((n) => { if (!customElements.get(n)) customElements.define(n, class extends TcbDialog {}); });

  document.addEventListener('tcb:dialog-open', (e) => {
    $$('x-popover[open]').forEach((p) => { if (p !== e.detail) p.hide(); });
  });

  // abrir/fechar pelos botões que controlam o diálogo; fechar por close-button e Escape
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[is="close-button"]');
    if (closeBtn) {
      const dlg = closeBtn.closest('x-drawer,x-popover,cart-drawer,search-drawer,navigation-drawer,quick-buy-drawer,facet-drawer');
      if (dlg) { e.preventDefault(); dlg.hide(); return; }
    }
    const ctl = e.target.closest('[aria-controls]');
    if (ctl) {
      const dlg = document.getElementById(ctl.getAttribute('aria-controls'));
      if (dlg && dlg instanceof TcbDialog) {
        if (ctl.tagName === 'A') e.preventDefault();
        e.preventDefault();
        dlg.toggle();
        return;
      }
    }
    // clique fora fecha popovers abertos
    $$('x-popover[open]').forEach((p) => {
      if (!p.contains(e.target)) p.hide();
    });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = $$('[open]').filter((d) => d instanceof TcbDialog).pop();
    if (open) open.hide();
    $$('details[is="dropdown-disclosure"][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ---------------- menus suspensos (details is="dropdown-disclosure") ---------------- */
  const dropdowns = () => {
    const SEL = 'details[is="dropdown-disclosure"], details[is="mega-menu-disclosure"]';
    const fine = () => matchMedia('screen and (pointer: fine)').matches;
    const content = (d) => d.lastElementChild;
    const openD = (d) => {
      if (d.hasAttribute('open') && !d._closing) return;
      d._closing = false;
      const sibs = $$(':scope > li > details[open], :scope details[open]', d.closest('ul') || document).filter((x) => x !== d && x.matches(SEL) && !x.contains(d));
      sibs.forEach(closeD);
      d.setAttribute('open', '');
      const c = content(d);
      c.style.opacity = '1';
      if (!reduce) {
        const delay = sibs.length ? 100 : 0;
        c.animate({ opacity: [0, 1] }, { duration: 200, delay, fill: 'backwards' });
        $$(':scope > ul > li', c).forEach((li, i) => li.animate({ opacity: [0, 1], transform: ['translateY(-10px)', 'translateY(0)'] },
          { duration: 200, delay: delay + 100 + i * 25, fill: 'backwards' }));
      }
    };
    const closeD = (d) => {
      if (!d.hasAttribute('open')) return;
      d._closing = true;
      const c = content(d);
      const fin = () => { if (d._closing) { d.removeAttribute('open'); c.style.opacity = ''; d._closing = false; } };
      if (reduce) return fin();
      c.animate({ opacity: [getComputedStyle(c).opacity, 0] }, { duration: 200 }).finished.then(fin, fin);
    };
    $$(SEL).forEach((d) => {
      const sum = d.firstElementChild;
      sum.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.getAttribute('trigger') === 'hover' && fine()) { if (sum.hasAttribute('data-url')) location.href = sum.getAttribute('data-url'); return; }
        (d.hasAttribute('open') && !d._closing) ? closeD(d) : openD(d);
      });
      let t;
      const hov = (e) => {
        if (d.getAttribute('trigger') !== 'hover' || !fine()) return;
        if (e.type === 'mouseover') { clearTimeout(t); openD(d); } else t = setTimeout(() => closeD(d), d.matches('[is="mega-menu-disclosure"]') ? 500 : 250);
      };
      d.addEventListener('mouseover', hov); d.addEventListener('mouseout', hov);
      d.addEventListener('focusout', (e) => { if (e.relatedTarget && !d.contains(e.relatedTarget)) closeD(d); });
    });
    document.addEventListener('click', (e) => {
      $$(SEL).forEach((d) => { if (d.hasAttribute('open') && !d.contains(e.target) && !(e.target.closest('details') && e.target.closest('details').matches(SEL))) closeD(d); });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { const d = e.target.closest && e.target.closest('details[open]'); if (d && d.matches(SEL)) closeD(d); } });

    // accordion-disclosure: altura animada
    $$('details[is="accordion-disclosure"]').forEach((d) => {
      const sum = d.firstElementChild, c = d.lastElementChild;
      d.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      sum.addEventListener('click', async (e) => {
        e.preventDefault();
        const willOpen = !d.hasAttribute('open');
        d.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        d.style.overflow = 'hidden';
        if (willOpen) {
          d.setAttribute('open', '');
          if (!reduce) {
            const a = d.animate({ height: [`${sum.clientHeight}px`, `${d.scrollHeight}px`] }, { duration: 250, easing: 'ease' });
            c.animate({ opacity: [0, 1], transform: ['translateY(0)', 'translateY(-4px)'] }, { duration: 150, delay: 150, fill: 'backwards' });
            await a.finished.catch(() => {});
          }
        } else {
          if (!reduce) {
            c.animate({ opacity: [1, 0] }, { duration: 150, fill: 'forwards' });
            await d.animate({ height: [`${d.clientHeight}px`, `${sum.clientHeight}px`] }, { duration: 250, easing: 'ease' }).finished.catch(() => {});
            c.getAnimations().forEach((x) => x.cancel());
          }
          d.removeAttribute('open');
        }
        d.style.height = 'auto'; d.style.overflow = 'visible';
      });
    });
  };

  /* ---------------- height-observer: --<variable>-height no :root ---------------- */
  const heightObservers = () => {
    const set = (el) => document.documentElement.style.setProperty(`--${el.getAttribute('variable')}-height`, `${el.clientHeight.toFixed(1)}px`);
    const ro = new ResizeObserver((ents) => ents.forEach((en) => set(en.target)));
    $$('height-observer[variable]').forEach((el) => { set(el); ro.observe(el); });
  };

  /* ---------------- contador da barra (Essential Countdown Timer: recorrente até 21:59 UTC) ---------------- */
  const countdown = () => {
    $$('[data-tcb-countdown]').forEach((bar) => {
      const [hh, mm] = bar.getAttribute('data-tcb-countdown').split(':').map(Number);
      const spans = $$('[class*="countdown_time_"]', bar);
      const tick = () => {
        const now = new Date();
        const end = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), hh, mm, 0));
        if (end <= now) end.setUTCDate(end.getUTCDate() + 1);
        let s = Math.max(0, Math.floor((end - now) / 1000));
        const h = Math.floor(s / 3600); s -= h * 3600; const m = Math.floor(s / 60); s -= m * 60;
        [h, m, s].forEach((v, i) => { if (spans[i]) spans[i].textContent = String(v).padStart(2, '0'); });
      };
      tick(); setInterval(tick, 1000);
    });
  };

  /* ---------------- carrosséis (scroll-carousel + prev/next + page-dots) ---------------- */
  const carousels = () => {
    const itemsOf = (c) => {
      const sel = c.getAttribute('selector');
      const list = sel ? $$(sel, c) : Array.from(c.children.length === 1 && c.children[0].children.length ? c.children[0].children : c.children);
      return list.filter((x) => x.offsetParent !== null || x.getClientRects().length);
    };
    const step = (c, dir) => {
      const its = itemsOf(c);
      if (!its.length) return;
      const w = its[0].getBoundingClientRect().width + parseFloat(getComputedStyle(its[0].parentElement).columnGap || 0);
      const per = Math.max(1, Math.floor((c.clientWidth + 1) / w));
      c.scrollBy({ left: dir * w * per, behavior: reduce ? 'auto' : 'smooth' });
    };
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[is="prev-button"],[is="next-button"]');
      if (!b) return;
      const c = document.getElementById(b.getAttribute('aria-controls'));
      if (!c) return;
      e.preventDefault();
      if (c.tagName === 'X-SLIDESHOW' || c.tagName === 'SLIDESHOW-CAROUSEL') return;
      step(c, b.getAttribute('is') === 'prev-button' ? -1 : 1);
    });
    const sync = (c) => {
      const its = itemsOf(c);
      const max = c.scrollWidth - c.clientWidth;
      $$(`[is="prev-button"][aria-controls="${c.id}"]`).forEach((b) => (b.disabled = c.scrollLeft <= 2));
      $$(`[is="next-button"][aria-controls="${c.id}"]`).forEach((b) => (b.disabled = c.scrollLeft >= max - 2));
      const dots = $$(`page-dots[aria-controls="${c.id}"] button`);
      if (dots.length && its.length) {
        let idx = 0, best = 1e9;
        const cl = c.getBoundingClientRect().left;
        its.forEach((it, i) => { const d = Math.abs(it.getBoundingClientRect().left - cl); if (d < best) { best = d; idx = i; } });
        if (c.scrollLeft >= max - 2) idx = its.length - 1;
        dots.forEach((d, i) => d.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      }
    };
    $$('scroll-carousel').forEach((c) => {
      if (!c.id) return;
      c.addEventListener('scroll', () => sync(c), { passive: true });
      new ResizeObserver(() => sync(c)).observe(c);
      sync(c);
    });
    // is-scrollable (controla .peer-not-scrollable:hidden, como pontos e setas)
    $$('scroll-carousel, image-link-blocks, .scroll-area').forEach((el) => {
      const chk = () => el.classList.toggle('is-scrollable', el.scrollWidth > el.clientWidth || el.scrollHeight - el.clientHeight > 1);
      new ResizeObserver(chk).observe(el);
      chk();
    });
    // barra de progresso da rolagem horizontal
    $$('scroll-progress[observes]').forEach((p) => {
      const el = document.getElementById(p.getAttribute('observes'));
      if (!el) return;
      const upd = () => {
        const left = document.dir === 'rtl' ? Math.abs(el.scrollLeft) : el.scrollLeft;
        p.style.setProperty('--scroll-progress', Math.max(0, Math.min((left + el.clientWidth) / el.scrollWidth, 1)).toFixed(6));
      };
      el.addEventListener('scroll', upd, { passive: true });
      new ResizeObserver(upd).observe(el);
      upd();
    });
    document.addEventListener('click', (e) => {
      const d = e.target.closest('page-dots button');
      if (!d) return;
      const pd = d.closest('page-dots');
      const c = document.getElementById(pd.getAttribute('aria-controls'));
      if (!c || c.tagName !== 'SCROLL-CAROUSEL') return;
      const its = itemsOf(c);
      const i = $$('button', pd).indexOf(d);
      if (its[i]) c.scrollTo({ left: its[i].offsetLeft - its[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    });
  };

  /* ---------------- carrinho (API nativa + gaveta renderizada pela seção tcb-cart-drawer) ---------------- */
  const cart = {
    async refresh(open) {
      const r = await fetch(`${T.routes?.root || '/'}?section_id=tcb-cart-drawer`, { credentials: 'same-origin' });
      const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('cart-drawer');
      const cur = document.getElementById('cart-drawer');
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
        init.cartDrawer();
        carousels.done = false;
        $$('scroll-carousel', cur).forEach((c) => c.dispatchEvent(new Event('scroll')));
      }
      // página /cart: re-renderiza a seção
      const page = document.getElementById('shopify-section-tcb-main-cart');
      if (page) {
        const h = await (await fetch(`${T.routes?.root || '/'}cart?section_id=tcb-main-cart`, { credentials: 'same-origin' })).text();
        const fresh = new DOMParser().parseFromString(h, 'text/html').getElementById('shopify-section-tcb-main-cart');
        if (fresh) { page.innerHTML = fresh.innerHTML; init.cartDrawer(); document.dispatchEvent(new CustomEvent('tcb:content', { detail: page })); }
      }
      const js = await (await fetch(`${T.routes?.root || '/'}cart.js`, { credentials: 'same-origin' })).json();
      $$('cart-count').forEach((c) => (c.textContent = js.item_count));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: js }));
      if (open && cur) cur.show();
      return js;
    },
    async change(key, quantity) {
      await fetch(`${T.routes?.root || '/'}cart/change.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      return this.refresh(false);
    },
    async add(form, extra) {
      const fd = new FormData(form);
      const idv = fd.get('id') || form.querySelector('[name="id"]')?.value;
      const qv = fd.get('quantity') || (form.elements.quantity && form.elements.quantity.value) || 1;
      const items = [{ id: Number(idv), quantity: Number(qv), properties: {} }];
      for (const [k, v] of fd.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m && v !== '') items[0].properties[m[1]] = v;
      }
      if (extra) items.push(...extra);
      const r = await fetch(`${T.routes?.root || '/'}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'add'); }
      // quick-buy (Impact): a própria gaveta mostra "Produit ajouté au panier !" e a gaveta do carrinho não abre
      const qb = form.closest('quick-buy-drawer');
      if (qb) {
        const res = await r.json().catch(() => ({}));
        const it = (res.items && res.items[0]) || res;
        try {
          const h = await (await fetch(`${T.routes?.root || '/'}products/${it.handle}?variant=${it.variant_id || idv}&section_id=tcb-variant-added`)).text();
          const sec = new DOMParser().parseFromString(h, 'text/html').querySelector('.shopify-section');
          if (sec) {
            const c = qb.shadowRoot && qb.shadowRoot.querySelector('[part="content"]');
            const from = c ? c.clientHeight : 0;
            qb.replaceChildren(...Array.from(sec.children).map((x) => document.importNode(x, true)));
            if (c && !reduce) {
              const to = c.clientHeight;
              c.animate({ height: [`${from}px`, `${to}px`] }, { duration: 350, easing: 'cubic-bezier(.86,0,.07,1)' });
              Array.from(c.children).forEach((x) => x.animate({ opacity: [0, 1] }, { duration: 150, delay: 200, fill: 'backwards' }));
            }
            qb._loaded = false;   // reabre com o seletor
          }
        } catch (e) { /* noop */ }
        return this.refresh(false);
      }
      if (window.tcbInterceptAdd && window.tcbInterceptAdd(form)) return this.refresh(false);
      return this.refresh(true);
    }
  };
  window.tcbCart = cart;

  const init = {
    cartDrawer() {
      const d = document.getElementById('cart-drawer');
      if (!d) return;
      $$('free-shipping-bar', d).forEach((b) => {
        const th = parseFloat(b.getAttribute('threshold') || '0') * 100;
        const tot = parseInt(b.getAttribute('total-price') || '0', 10);
        const span = b.querySelector('span');
        const pb = b.querySelector('progress-bar');
        if (tot >= th) {
          if (span) span.innerHTML = b.getAttribute('reached-message');
          if (pb) pb.style.setProperty('--progress', '1');
        } else {
          if (span) span.innerHTML = (b.getAttribute('unreached-message') || '').replace('{{ remaining_amount }}', money(th - tot));
          if (pb) pb.style.setProperty('--progress', String(tot / th));
        }
        if (pb) { pb.setAttribute('aria-valuenow', Math.min(tot, th)); pb.setAttribute('aria-valuemax', th); }
      });
    }
  };

  const cartEvents = () => {
    init.cartDrawer();
    document.addEventListener('change', (e) => {
      const q = e.target.closest('input.quantity-input[data-line-key]');
      if (q) {
        const li = q.closest('line-item'); if (li) li.classList.add('is-loading');
        cart.change(q.getAttribute('data-line-key'), Math.max(0, parseInt(q.value || '0', 10)));
      }
    });
    document.addEventListener('click', (e) => {
      const rm = e.target.closest('line-item a[href*="/cart/change"]');
      if (!rm || !(rm.closest('#cart-drawer') || rm.closest('#shopify-section-tcb-main-cart'))) return;
      e.preventDefault();
      const key = new URL(rm.href, location.origin).searchParams.get('id');
      const li = rm.closest('line-item'); if (li) li.classList.add('is-loading');
      cart.change(key, 0);
    });
    // formulário de compra (cards e PDP): adiciona pela API e abre a gaveta
    document.addEventListener('submit', (e) => {
      const f = e.target;
      if (!(f instanceof HTMLFormElement)) return;
      const act = (f.getAttribute('action') || '').split('?')[0];
      if (!/\/cart\/add$/.test(act)) return;
      if (f.closest('[data-tcb-native-form]')) return;
      e.preventDefault();
      const btn = e.submitter || f.querySelector('[type="submit"]');
      btn?.setAttribute('aria-busy', 'true');
      document.dispatchEvent(new CustomEvent('tcb:before-add', { detail: f }));
      const extra = (window.tcbExtraItems && window.tcbExtraItems(f)) || null;
      f.querySelectorAll('.banner--error').forEach((x) => x.remove());
      cart.add(f, extra).catch((err) => {
        // erro do carrinho (ex.: estoque): faixa de erro dentro de buy-buttons, como o Impact
        const bb = f.querySelector('buy-buttons') || document.querySelector(`buy-buttons[form="${f.id}"]`);
        if (!bb) return;
        const ban = document.createElement('div');
        ban.className = 'banner banner--error justify-center'; ban.setAttribute('role', 'alert');
        ban.style.gridColumn = '1/-1'; ban.style.marginBottom = '1rem';
        ban.textContent = err.message;
        bb.prepend(ban);
      }).finally(() => btn?.removeAttribute('aria-busy'));
    });
  };

  /* ---------------- busca preditiva (slots idle/loading/results, como o Impact) ---------------- */
  if (!customElements.get('x-tabs')) {
    customElements.define('x-tabs', class extends HTMLElement {
      connectedCallback() {
        if (!this.shadowRoot) { const t = this.querySelector('template'); if (t) this.attachShadow({ mode: 'open' }).appendChild(t.content.cloneNode(true)); }
        const sr = this.shadowRoot; if (!sr) return;
        this.buttons = sr.querySelector('slot[name="title"]').assignedElements().map((x) => (x.matches('button') ? x : x.querySelector('button')));
        this.panels = sr.querySelector('slot[name="content"]').assignedElements();
        const uid = Math.floor(Math.random() * 1e6);
        this.buttons.forEach((b, i) => { b.setAttribute('role', 'tab'); b.id = `tab-${uid}-${i}`; b.setAttribute('aria-controls', `tab-panel-${uid}-${i}`); b.addEventListener('click', () => this.select(i)); });
        this.panels.forEach((p, i) => { p.setAttribute('role', 'tabpanel'); p.id = `tab-panel-${uid}-${i}`; p.setAttribute('aria-labelledby', `tab-${uid}-${i}`); });
        this.select(parseInt(this.getAttribute('selected-index'), 10) || 0, true);
      }
      async select(i, init) {
        const old = parseInt(this.getAttribute('selected-index'), 10) || 0;
        i = Math.min(Math.max(i, 0), this.buttons.length - 1);
        this.setAttribute('selected-index', String(i));
        this.style.setProperty('--selected-index', String(i)); this.style.setProperty('--item-count', String(this.buttons.length));
        this.buttons.forEach((b, k) => b.setAttribute('aria-selected', k === i ? 'true' : 'false'));
        if (init) { this.panels.forEach((p, k) => (p.hidden = k !== i)); return; }
        if (old === i) return;
        const from = this.panels[old], to = this.panels[i];
        if (from) await from.animate({ opacity: [1, 0] }, { duration: 150 }).finished.catch(() => {});
        if (from) from.hidden = true; to.hidden = false;
        to.animate({ opacity: [0, 1] }, { duration: 150 });
      }
    });
  }
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      constructor() { super(); this.attachShadow({ mode: 'open' }).innerHTML = '<slot name="idle"></slot>'; }
      connectedCallback() {
        this.form = this.closest('form'); this.input = this.form?.elements.q;
        if (!this.input) return;
        let t;
        this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.changed(), 280); });
        this.form.addEventListener('submit', (e) => { if (this.input.value === '') e.preventDefault(); });
        this.form.addEventListener('reset', () => { this.ctrl?.abort(); this.input.focus(); this.to('idle'); });
      }
      async changed() {
        if (this.input.value === '') { this.ctrl?.abort(); return this.to('idle'); }
        this.ctrl?.abort(); this.ctrl = new AbortController();
        await this.to('loading');
        try {
          const q = `q=${encodeURIComponent(this.input.value)}&section_id=tcb-predictive-search&resources[limit]=10&resources[limit_scope]=each`;
          const html = await (await fetch(`${T.routes?.predictive || '/search/suggest'}?${q}`, { signal: this.ctrl.signal })).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[slot="results"]');
          const cur = this.querySelector('[slot="results"]');
          if (fresh && cur) cur.replaceWith(document.importNode(fresh, true));
          await this.to('results');
        } catch (e) { if (e.name !== 'AbortError') console.warn('[tcb] search', e); }
      }
      async to(name) {
        const slot = this.shadowRoot.firstElementChild;
        if (slot.name === name) return;
        await Promise.all(slot.assignedNodes().filter((n) => n.animate).map((n) => n.animate({ opacity: [1, 0] }, { duration: 100 }).finished.catch(() => {})));
        slot.name = name;
        slot.assignedNodes().filter((n) => n.animate).forEach((n) => n.animate({ opacity: [0, 1] }, { duration: 100 }));
      }
    });
  }
  const predictive = () => {
    // foco no campo ao abrir a gaveta de busca
    document.addEventListener('dialog:after-show', (e) => {
      if (e.target.matches && e.target.matches('search-drawer')) setTimeout(() => e.target.querySelector('input[name="q"]')?.focus(), 50);
    });
  };

  /* ---------------- custom-button (conteúdo em <div> + loader) e product-form (id habilitado) ---------------- */
  const buttons = (root = document) => {
    root.querySelectorAll('button[is="custom-button"]').forEach((b) => {
      if (b.querySelector(':scope > .button__loader')) return;
      const d = document.createElement('div'); d.append(...b.childNodes);
      const l = document.createElement('span'); l.className = 'button__loader'; l.innerHTML = '<span></span><span></span><span></span>';
      b.append(d, l);
    });
    root.querySelectorAll('form[is="product-form"] input[name="id"][disabled]').forEach((i) => (i.disabled = false));
  };
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) buttons(n.parentNode || n); }))).observe(document.documentElement, { childList: true, subtree: true });
  addEventListener('pageshow', () => document.querySelectorAll('[aria-busy="true"]').forEach((x) => x.removeAttribute('aria-busy')));

  const run = (name, fn) => { try { fn(); } catch (e) { console.warn('[tcb]', name, e); } };
  const start = () => {
    run('buttons', buttons);
    run('dropdowns', dropdowns);
    run('height', heightObservers);
    run('countdown', countdown);
    run('carousels', carousels);
    run('cart', cartEvents);
    run('predictive', predictive);
    (window.tcbModules || []).forEach((m) => run(m.name || 'mod', m));
    document.dispatchEvent(new Event('tcb:ready'));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
